export default {
  namespaced: true,
  state: {
    userInfo: {
      id: '1234567',
      name: 'Adam Jahr'
    }
  }
};
